<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 5H7a2 2 0 00-2 2v42a2 2 0 002 2h14v6.09a2 2 0 001 1.75 1.94 1.94 0 001 .25 2 2 0 001.08-.31L36.35 51H57a2 2 0 002-2V7a2 2 0 00-2-2zm-1 43H35.48L24 55.27V48H8V8h48z"/></svg>